import React, { useRef, useState } from 'react'
import SecondaryButton from './SecondaryButton'
import PrimaryButton from './PrimaryButton'
import { useNavigate } from 'react-router-dom';
import CreateAction from "../../components/operational/createAction";
import MobligoLogo from '../../assets/img/mobligo_new.png';
import ThemeOptions from './ThemeOptions';
import ThemesModalLanguageSelect from '../../pages/DashboardPages/Modals/ThemesModalLanguageSelect.jsx';
import { Menu } from 'primereact/menu';
import { SVG_Eye_Outline, SVG_Rocket_2_Linear, SVG_Rocket_Linear, SVG_Text_Bold, SVG_Trash_Bin_Trash_Linear } from '@dev-mobligo/iconpack'
import { Copy, Thrash } from '../../assets/svgs'
import ThemesModalNameChanger from '../../pages/DashboardPages/Modals/ThemesModalNameChanger';
import { useSelector } from 'react-redux';
import ThemeLicenseModal from '../../pages/ThemeScreen/DnDNew/components/Modals/ThemeLicenseModal';

const ThemeCard = ({ theme, getThemes, themes, setThemeId }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [open, setOpen] = useState(false)

  const [isNameChangerOpen, setIsNameChangerOpen] = useState(false)
  const navigate = useNavigate();

  const setMainTheme = async (themeId) => {

    const response = await CreateAction({
      method: "patch",
      path: `/setMainTheme/${themeId}`,
      showPreLoader: true,
      isFileUploading: false,
      toastMessage: {
        success: "success"
      },

    }

    );
    if (response?.error) return

    getThemes()
    return { success: "" }
  }


  const menuRight = useRef(null);
  const items = [
    {
      template: () => {
        return (
          <div className=' group-hover:right-[15px] right-[-50px] top-[15px] flex flex-col gap-[15px] duration-300 z-[20] p-3'>
            <div className='bg-white p-[5px] cursor-pointer border-b-1'>
              <SecondaryButton
                classes={` rounded-lg text-[14px] text-[#7059EF] flex justify-center items-center font-medium !border-0 !p-0
            ${""} `}
                onClick={() => { copyTheme(theme?.id) }}
                value={
                  <>
                    <Copy className={"hover:stroke-[#7059ef] duration-300    stroke-[#5E5873] shrink-0   fill-white stroke-2 w-[24px] h-[24px]"}></Copy>
                    <span >Kopyala</span>
                  </>
                }
                confirmationMessage={"copyApp"}
              ></SecondaryButton>
            </div>


            <div className={`bg-white p-[5px] cursor-pointer ${theme?.isMain ? "" : "border-b-1"}`}>

              <SecondaryButton
                classes={` rounded-lg text-[14px] text-[#7059EF] flex justify-center items-center font-medium  !border-0 !p-0`}
                onClick={() => { setIsNameChangerOpen(true) }}
                value={
                  <>
                    <SVG_Text_Bold className={"hover:stroke-[#7059ef] hover:fill-[#7059ef] duration-300    stroke-[#5E5873] shrink-0 stroke-[0.5px]  fill-[#5E5873] w-[24px] h-[24px]"}></SVG_Text_Bold>
                    <span >Adını Değiştir</span>
                  </>


                }

              ></SecondaryButton>
            </div >

            {!theme.isMain &&

              <div className='bg-white p-[5px] cursor-pointer'>
                <SecondaryButton
                  classes={` rounded-lg text-[14px] text-[#7059EF] flex justify-center items-center font-medium  !border-0 !p-0`}
                  onClick={() => { deleteTheme(theme?.id) }}
                  value={
                    <>
                      <SVG_Trash_Bin_Trash_Linear className='hover:stroke-red-500 duration-300  stroke-red-500 stroke-[0.5px] shrink-0  w-[24px] h-[24px]'></SVG_Trash_Bin_Trash_Linear>
                      <span className='text-red-500' >Sil</span>
                    </>

                  }
                  confirmationMessage={"deleteTheme"}
                ></SecondaryButton>

              </div>
            }
          </div>
        );
      }
    },
  ];

  const deleteTheme = async (themeId) => {


    const response = await CreateAction({
      method: "delete",
      path: `/mainTheme/${themeId}`,
      showPreLoader: true,
      isFileUploading: false,
      toastMessage: {
        success: "success"
      }

    }
    );
    if (response?.error) return
    getThemes()

  }
  const copyTheme = async (themeId) => {

    const response = await CreateAction({
      method: "post",
      path: `/copyMainTheme/${themeId}`,
      showPreLoader: true,
      isFileUploading: false,
      toastMessage: {
        success: "success"
      }
    }
    );
    if (response?.error) return

    getThemes()
    return { success: "" }


  }


  const setDraftToLiveAll = async () => {
    const response = await CreateAction({
      method: 'post',
      path: `/setDraftToLiveFromMainId/${theme.id}`,
      showPreLoader: true,
      isFileUploading: false
    });

    if (response?.error) return
    getThemes()
    return { success: "" }

  }
  const isDemo = theme?.themeData?.[0]?.settings?.isDemo
  return (
    <>
      <div
        className="px-[48px] border-b-2 border-[#E1E1E1] last:border-0"
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '100px',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
          <div className="truncate" style={{ width: '180px' }}>
            {theme?.name}
          </div>
          {theme?.isMain &&
            <div>
              <div className=" right-[15px] top-[15px] bg-[#E1D4FF] rounded-md py-[3px] px-[7px] py-[3px] text-[14px] text-[#7059ef] flex flex-row items-center gap-[5px]">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http:www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.58 12.2213L15.5501 7.266C16.2659 6.55237 16.6238 6.19555 16.8123 5.7418C17.0008 5.28806 17.0008 4.78345 17.0008 3.77424V3.29209C17.0008 1.74019 17.0008 0.964232 16.5173 0.482116C16.0337 0 15.2554 0 13.6988 0H13.2153C12.203 0 11.6969 0 11.2418 0.187947C10.7867 0.375893 10.4288 0.732709 9.71298 1.44634L4.7428 6.40162C3.90641 7.2355 3.3878 7.75255 3.18698 8.25195C3.12352 8.40974 3.0918 8.56577 3.0918 8.72948C3.0918 9.41129 3.64213 9.95998 4.7428 11.0573L4.89072 11.2048L6.62359 9.44612C6.87072 9.1953 7.27438 9.19231 7.52519 9.43944C7.776 9.68657 7.77899 10.0902 7.53187 10.341L5.79372 12.1051L5.91023 12.2213C7.01089 13.3186 7.56123 13.8673 8.24509 13.8673C8.39619 13.8673 8.54078 13.8405 8.68622 13.787C9.19902 13.5981 9.72249 13.0762 10.58 12.2213ZM12.9149 6.40198C12.2702 7.0448 11.2248 7.0448 10.5801 6.40198C9.93531 5.75916 9.93531 4.71694 10.5801 4.07412C11.2248 3.4313 12.2702 3.4313 12.9149 4.07412C13.5597 4.71694 13.5597 5.75916 12.9149 6.40198Z"
                    fill="#7059EF"
                  />
                  <path
                    d="M5.97958 3.36904L3.81775 5.52438C3.42038 5.92054 3.05586 6.28394 2.768 6.61246C2.58314 6.82342 2.39841 7.05432 2.24192 7.30946L2.22086 7.28846C2.18088 7.2486 2.16086 7.22864 2.14078 7.20916C1.76503 6.84457 1.32304 6.5547 0.838465 6.35505C0.812569 6.34438 0.786287 6.33397 0.733725 6.31314L0.41185 6.1856C-0.0241994 6.01282 -0.140412 5.45147 0.191385 5.12068C1.14363 4.17132 2.28693 3.03147 2.8387 2.80253C3.32531 2.60063 3.85098 2.53345 4.35796 2.60838C4.82249 2.67703 5.26193 2.91564 5.97958 3.36904Z"
                    fill="#7059EF"
                  />
                  <path
                    d="M9.67088 14.7175C9.84508 14.8943 9.96079 15.0192 10.0654 15.1526C10.2034 15.3287 10.3268 15.5157 10.4343 15.7118C10.5554 15.9326 10.6494 16.1684 10.8374 16.64C10.9905 17.0239 11.4989 17.1254 11.7942 16.831L11.8657 16.7597C12.8179 15.8104 13.9611 14.6705 14.1908 14.1204C14.3933 13.6352 14.4607 13.1111 14.3855 12.6057C14.3167 12.1426 14.0774 11.7045 13.6227 10.9892L11.4537 13.1517C11.0473 13.5569 10.6747 13.9284 10.3377 14.2195C10.1358 14.3939 9.91483 14.5682 9.67088 14.7175Z"
                    fill="#7059EF"
                  />
                </svg>
                <span >
                  Yayındaki Tema

                </span>
              </div>
            </div>

          }
          {/* <div>
            <div className="flex items-center  right-[15px] top-[15px] border border-[#E1D4FF] rounded-md py-[3px] px-[7px] py-[3px] text-[14px] text-[#7059ef] gap-[5px]">
              <svg
                width="14"
                height="14"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http:www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.58 12.2213L15.5501 7.266C16.2659 6.55237 16.6238 6.19555 16.8123 5.7418C17.0008 5.28806 17.0008 4.78345 17.0008 3.77424V3.29209C17.0008 1.74019 17.0008 0.964232 16.5173 0.482116C16.0337 0 15.2554 0 13.6988 0H13.2153C12.203 0 11.6969 0 11.2418 0.187947C10.7867 0.375893 10.4288 0.732709 9.71298 1.44634L4.7428 6.40162C3.90641 7.2355 3.3878 7.75255 3.18698 8.25195C3.12352 8.40974 3.0918 8.56577 3.0918 8.72948C3.0918 9.41129 3.64213 9.95998 4.7428 11.0573L4.89072 11.2048L6.62359 9.44612C6.87072 9.1953 7.27438 9.19231 7.52519 9.43944C7.776 9.68657 7.77899 10.0902 7.53187 10.341L5.79372 12.1051L5.91023 12.2213C7.01089 13.3186 7.56123 13.8673 8.24509 13.8673C8.39619 13.8673 8.54078 13.8405 8.68622 13.787C9.19902 13.5981 9.72249 13.0762 10.58 12.2213ZM12.9149 6.40198C12.2702 7.0448 11.2248 7.0448 10.5801 6.40198C9.93531 5.75916 9.93531 4.71694 10.5801 4.07412C11.2248 3.4313 12.2702 3.4313 12.9149 4.07412C13.5597 4.71694 13.5597 5.75916 12.9149 6.40198Z"
                  fill="#7059EF"
                />
                <path
                  d="M5.97958 3.36904L3.81775 5.52438C3.42038 5.92054 3.05586 6.28394 2.768 6.61246C2.58314 6.82342 2.39841 7.05432 2.24192 7.30946L2.22086 7.28846C2.18088 7.2486 2.16086 7.22864 2.14078 7.20916C1.76503 6.84457 1.32304 6.5547 0.838465 6.35505C0.812569 6.34438 0.786287 6.33397 0.733725 6.31314L0.41185 6.1856C-0.0241994 6.01282 -0.140412 5.45147 0.191385 5.12068C1.14363 4.17132 2.28693 3.03147 2.8387 2.80253C3.32531 2.60063 3.85098 2.53345 4.35796 2.60838C4.82249 2.67703 5.26193 2.91564 5.97958 3.36904Z"
                  fill="#7059EF"
                />
                <path
                  d="M9.67088 14.7175C9.84508 14.8943 9.96079 15.0192 10.0654 15.1526C10.2034 15.3287 10.3268 15.5157 10.4343 15.7118C10.5554 15.9326 10.6494 16.1684 10.8374 16.64C10.9905 17.0239 11.4989 17.1254 11.7942 16.831L11.8657 16.7597C12.8179 15.8104 13.9611 14.6705 14.1908 14.1204C14.3933 13.6352 14.4607 13.1111 14.3855 12.6057C14.3167 12.1426 14.0774 11.7045 13.6227 10.9892L11.4537 13.1517C11.0473 13.5569 10.6747 13.9284 10.3377 14.2195C10.1358 14.3939 9.91483 14.5682 9.67088 14.7175Z"
                  fill="#7059EF"
                />
              </svg>
              Hazır
            </div>
          </div> */}
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', height: 'max-content' }}>

          {theme?.themeData?.filter(themeData => themeData?.draftData)?.length > 0 && theme?.isMain &&
            <>
              <PrimaryButton
                confirmationMessage={'isDraftPublishAll'}
                classes={'p-3 !bg-green-600'}
                onClick={() => {
                  setDraftToLiveAll();
                }}
                value={'Temayı Güncelle'}
              />
            </>
          }

          {!theme?.isMain && !isDemo &&
            <SecondaryButton
              confirmationMessage={"isPublishApp"}
              onClick={() => {
                if (!theme?.isPublishable) {
                  return setOpen(true)
                }
                setMainTheme(theme?.id)
              }}
              classes="border-[#7059EF] text-[#7059EF]"
              value={
                <>
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http:www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.58 12.2213L15.5501 7.266C16.2659 6.55237 16.6238 6.19555 16.8123 5.7418C17.0008 5.28806 17.0008 4.78345 17.0008 3.77424V3.29209C17.0008 1.74019 17.0008 0.964232 16.5173 0.482116C16.0337 0 15.2554 0 13.6988 0H13.2153C12.203 0 11.6969 0 11.2418 0.187947C10.7867 0.375893 10.4288 0.732709 9.71298 1.44634L4.7428 6.40162C3.90641 7.2355 3.3878 7.75255 3.18698 8.25195C3.12352 8.40974 3.0918 8.56577 3.0918 8.72948C3.0918 9.41129 3.64213 9.95998 4.7428 11.0573L4.89072 11.2048L6.62359 9.44612C6.87072 9.1953 7.27438 9.19231 7.52519 9.43944C7.776 9.68657 7.77899 10.0902 7.53187 10.341L5.79372 12.1051L5.91023 12.2213C7.01089 13.3186 7.56123 13.8673 8.24509 13.8673C8.39619 13.8673 8.54078 13.8405 8.68622 13.787C9.19902 13.5981 9.72249 13.0762 10.58 12.2213ZM12.9149 6.40198C12.2702 7.0448 11.2248 7.0448 10.5801 6.40198C9.93531 5.75916 9.93531 4.71694 10.5801 4.07412C11.2248 3.4313 12.2702 3.4313 12.9149 4.07412C13.5597 4.71694 13.5597 5.75916 12.9149 6.40198Z"
                      fill="#7059EF"
                    />
                    <path
                      d="M5.97958 3.36904L3.81775 5.52438C3.42038 5.92054 3.05586 6.28394 2.768 6.61246C2.58314 6.82342 2.39841 7.05432 2.24192 7.30946L2.22086 7.28846C2.18088 7.2486 2.16086 7.22864 2.14078 7.20916C1.76503 6.84457 1.32304 6.5547 0.838465 6.35505C0.812569 6.34438 0.786287 6.33397 0.733725 6.31314L0.41185 6.1856C-0.0241994 6.01282 -0.140412 5.45147 0.191385 5.12068C1.14363 4.17132 2.28693 3.03147 2.8387 2.80253C3.32531 2.60063 3.85098 2.53345 4.35796 2.60838C4.82249 2.67703 5.26193 2.91564 5.97958 3.36904Z"
                      fill="#7059EF"
                    />
                    <path
                      d="M9.67088 14.7175C9.84508 14.8943 9.96079 15.0192 10.0654 15.1526C10.2034 15.3287 10.3268 15.5157 10.4343 15.7118C10.5554 15.9326 10.6494 16.1684 10.8374 16.64C10.9905 17.0239 11.4989 17.1254 11.7942 16.831L11.8657 16.7597C12.8179 15.8104 13.9611 14.6705 14.1908 14.1204C14.3933 13.6352 14.4607 13.1111 14.3855 12.6057C14.3167 12.1426 14.0774 11.7045 13.6227 10.9892L11.4537 13.1517C11.0473 13.5569 10.6747 13.9284 10.3377 14.2195C10.1358 14.3939 9.91483 14.5682 9.67088 14.7175Z"
                      fill="#7059EF"
                    />
                  </svg>
                  Yayınla
                </>
              }
            />
          }

          {isDemo &&
            <SecondaryButton
              confirmationMessage={"isPublishApp"}
              isDisabled={true}
              classes="border-[#7059EF] text-[#7059EF]"
              value={
                <>
                  Demo Temadır
                </>
              }
            />
          }

          <SecondaryButton
            classes=""
            onClick={() => {
              setIsOpen(true)
            }}
            value={
              <>
                <svg
                  width="14"
                  height="17"
                  viewBox="0 0 14 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M1 16H13" stroke="#8A92A6" stroke-width="1.5" stroke-linecap="round" />
                  <path
                    d="M8.41604 2.24719L8.97217 1.69107C9.89359 0.769644 11.3875 0.769644 12.3089 1.69107C13.2304 2.61249 13.2304 4.10641 12.3089 5.02783L11.7528 5.58396M8.41604 2.24719C8.41604 2.24719 8.48556 3.42897 9.5283 4.47171C10.571 5.51444 11.7528 5.58396 11.7528 5.58396M8.41604 2.24719L3.30329 7.35994C2.957 7.70624 2.78385 7.87939 2.63494 8.0703C2.45928 8.29551 2.30868 8.53919 2.18581 8.79701C2.08164 9.01558 2.00421 9.24789 1.84934 9.71249L1.19308 11.6812M11.7528 5.58396L6.64006 10.6967C6.29376 11.043 6.12061 11.2162 5.9297 11.3651C5.70449 11.5407 5.46082 11.6913 5.20299 11.8142C4.98442 11.9184 4.75211 11.9958 4.28751 12.1507L2.31875 12.8069M2.31875 12.8069L1.8375 12.9673C1.60887 13.0435 1.35679 12.984 1.18638 12.8136C1.01596 12.6432 0.956457 12.3911 1.03267 12.1625L1.19308 11.6812M2.31875 12.8069L1.19308 11.6812"
                    stroke="#8A92A6"
                    stroke-width="1.5"
                  />
                </svg>
                Temayı Düzenle
              </>
            }
          />

          <div className="card flex justify-content-center">
            <Menu
              model={items}
              popup
              ref={menuRight}
              id="popup_menu_right"
              popupAlignment="right"
            />
            <SecondaryButton
              classes="border-none"
              value={
                <>
                  <svg
                    width="24px"
                    height="24px"
                    viewBox="0 0 0.42 0.42"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      cx="5.5"
                      cy="7.5"
                      r="1.5"
                      fill="#8A92A6"
                      d="M0.123 0.131A0.026 0.026 0 0 1 0.096 0.158A0.026 0.026 0 0 1 0.07 0.131A0.026 0.026 0 0 1 0.123 0.131z"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.14 0.114a0.009 0.009 0 0 1 0.009 -0.009h0.193a0.009 0.009 0 0 1 0 0.018h-0.193a0.009 0.009 0 0 1 -0.009 -0.009"
                      fill="#8A92A6"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.14 0.149a0.009 0.009 0 0 1 0.009 -0.009h0.105a0.009 0.009 0 0 1 0 0.018h-0.105a0.009 0.009 0 0 1 -0.009 -0.009"
                      fill="#8A92A6"
                    />
                    <path
                      cx="5.5"
                      cy="12"
                      r="1.5"
                      fill="#8A92A6"
                      d="M0.123 0.21A0.026 0.026 0 0 1 0.096 0.236A0.026 0.026 0 0 1 0.07 0.21A0.026 0.026 0 0 1 0.123 0.21z"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.14 0.193a0.009 0.009 0 0 1 0.009 -0.009h0.14a0.009 0.009 0 0 1 0 0.018h-0.14A0.009 0.009 0 0 1 0.14 0.193"
                      fill="#8A92A6"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.14 0.228a0.009 0.009 0 0 1 0.009 -0.009h0.123a0.009 0.009 0 0 1 0 0.018h-0.123A0.009 0.009 0 0 1 0.14 0.228"
                      fill="#8A92A6"
                    />
                    <path
                      cx="5.5"
                      cy="16.5"
                      r="1.5"
                      fill="#8A92A6"
                      d="M0.123 0.289A0.026 0.026 0 0 1 0.096 0.315A0.026 0.026 0 0 1 0.07 0.289A0.026 0.026 0 0 1 0.123 0.289z"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.14 0.271a0.009 0.009 0 0 1 0.009 -0.009H0.315a0.009 0.009 0 0 1 0 0.018H0.149a0.009 0.009 0 0 1 -0.009 -0.009"
                      fill="#8A92A6"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.14 0.306a0.009 0.009 0 0 1 0.009 -0.009h0.07a0.009 0.009 0 0 1 0 0.018h-0.07a0.009 0.009 0 0 1 -0.009 -0.009"
                      fill="#8A92A6"
                    />
                  </svg>
                  İşlemler
                </>
              }
              //@ts-ignore
              onClick={event => menuRight.current.toggle(event)}
            />
          </div>
        </div>
      </div>
      {isOpen && <ThemesModalLanguageSelect getThemes={getThemes} setThemeId={setThemeId} themes={themes} theme={theme} isOpen={isOpen} setIsOpen={setIsOpen}></ThemesModalLanguageSelect>}
      {open && <ThemeLicenseModal setOpen={setOpen}></ThemeLicenseModal>}
      {isNameChangerOpen && <ThemesModalNameChanger theme={theme} isOpen={isNameChangerOpen} setIsOpen={setIsNameChangerOpen} getThemes={getThemes}></ThemesModalNameChanger>}


    </>
  )
}

export default ThemeCard